import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function FinancingHero() {
  return <section className="bg-black pt-[180px] pb-[80px] lg:pt-[200px] lg:pb-[120px] relative overflow-hidden" data-id="element-1262">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10" data-id="element-1263">
        <AnimateOnScroll className="flex flex-col items-center text-center" data-id="element-1264">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-6 font-[Poppins,_sans-serif]" data-id="element-1265">
            FINANCING
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[60px] uppercase text-white tracking-tight mb-6 font-[500] font-[Poppins,_sans-serif] leading-none" data-id="element-1266">
            Financing Options at Be CLINICAL
          </h1>

          <p className="font-serif italic text-base sm:text-lg lg:text-xl text-white/85 leading-[1.6] mb-8 max-w-[700px] mx-auto" data-id="element-1267">
            Enjoy the benefits of your desired treatments today while paying
            over time. These flexible payment plans offer affordable solutions,
            letting you focus on your self-care without financial stress.
          </p>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-1268"></div>
        </AnimateOnScroll>
      </div>
    </section>;
}